<template>
  <!-- auto registration confirmation screen, confirmation if the user already has a registration -->
  <div class="container-fluid py-5">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-4 mx-auto">
        <div class="card card-signin my-5 card-opacity">
          <div class="card-body">
            <h3 class="card-title text-center" style="color: rgb(100, 95, 95)">
              Primeiro acesso
            </h3>
            <h5 class="card-title text-center text-join">
              Você já tem o LOGIN e SENHA para acessar o Portal?
            </h5>
          </div>
          <div class="access-center">
            <button
              class="btn btn-lg access-confirmation"
              id="yesAnswerSelfRegistration"
              type="submit"
              v-on:click="showLogin"
            >
              Sim
            </button>
            <button
              class="btn btn-lg access-confirmation"
              id="noAnswerSelfRegistration"
              type="submit"
              v-on:click="$emit('showForm')"
            >
              Não
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import router from "../../../router/router";


export default {
  name: "selfRegistrationConfirm",
  data() {
    return {
      logoImage: "",
    };
  },
  methods: {
    showLogin: function () {
      this.$router
        .push({
          path: `${this.$route.query.group}?token=${this.$route.query.token}`,
        })
        .catch(() => {});
    },

  },
  mounted() {
    let group = this.$route.query.group;

    axios.get(`${process.env.API_PBM}/group/${group}`).then((response) => {
      let background = response.data.data.background;
      let logo = response.data.data.logo;

      localStorage.removeItem("userLogged");
      localStorage.setItem("group", group);
      localStorage.setItem("themeColor", response.data.data.skin);
      localStorage.setItem("logo", logo);
      localStorage.setItem("logoVazado", response.data.data.logo_vazado);

      if (background != null) {
        document.body.className = "background-login";
        document.body.style.backgroundImage = `url("${background}")`;
      }
      if (logo != null) {
        this.logoImage = logo;
      }
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* body {
  background-image: url("https://portaldeboletos.com.br/images/background/GERDAU20180607154650000000.jpg");
  background-repeat: repeat-x;
} */
</style>
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-top: 70px;
}

.text-align-center {
  margin-top: 50px;
  color: rgb(100, 95, 95);
  font-size: 13px;
  text-align: center;
  margin-bottom: 50px;
}

.card-opacity {
  background: rgba(255, 255, 255, 0.9);
  border: none;
}

.access-confirmation {
  background-color: #b0191a;
  color: #fff;
  width: 35%;
  margin-top: 20px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  margin-bottom: 70px;
  text-decoration: none !important;
}
.access-center {
  display: flex;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/views/components/firstAccess/SelfRegistrationConfirm.vue